export class DepartmentModel {
    
    deptmId: number;
    deptmNameEn: string;	
    /* compaVaEmail1: string;
    compaVaHomepage: string; */
    deptmNuNumberBed: number;
    deptmNuNumberSpeciality:number;
   /*  compaVaWorkPhone: string;
    compaVaWorkFax: string;
    compaNuNumberEmployees:number; */
    
    partnerId:number;
    
    partnerType:number;
    assetType:string;
	assetSize:number;
	speciality:number;
    address:string;
    //staRecCode:boolean;
}